import React from 'react'

import SearchPopoverStateItems from './SearchPopoverStateItems'
// import SearchPopoverMetroItems from './SearchPopoverMetroItems'
import SearchPopoverMsaItems from './SearchPopoverMsaItems'
import SearchPopoverZip3Items from './SearchPopoverZip3Items'

// import SearchPopoverCountyItems from './SearchPopoverCountyItems'
// import SearchPopoverHrrItems from './SearchPopoverHrrItems'

import styles from './SearchPopover.module.scss'

const SearchPopover = React.forwardRef(
  (
    {
      criteria,
      onAdd,
      searchText,
      visible: isVisible,
      entity,
      activeMetros,
      activeZip3,
      showCounties,
      showMSAs,
      showStates,
      showHrrs,
      searchPopOverHeight,
      overflow,
      setSearchText,
      setSearchValue,
      setPopoverVisible,
      setSearchLocationValue,
      setSearchLocationTextMethod
    },
    ref
  ) => {
    return (
      <>
        <ul
          className={`${styles.base} ${isVisible ? styles.open : ''}`}
          ref={ref}
          style={{
            overflowY: overflow ? 'scroll' : 'hidden',
            height: searchPopOverHeight,
          }}
        >
          {showStates&&<SearchPopoverStateItems
            criteria={criteria}
            onAdd={onAdd}
            searchText={searchText}
            visible={isVisible}
            entity={entity}
            setSearchText={setSearchText}
            setSearchValue={setSearchValue}
            setPopoverVisible={setPopoverVisible}
            setSearchLocationValue={setSearchLocationValue}
            setSearchLocationTextMethod={setSearchLocationTextMethod}
          />}
           {showMSAs &&<SearchPopoverMsaItems
            criteria={criteria}
            onAdd={onAdd}
            searchText={searchText}
            visible={isVisible}
            entity={entity}
            activeMetros={activeMetros}
            setSearchText={setSearchText}
            setSearchValue={setSearchValue}
            setPopoverVisible={setPopoverVisible}
            setSearchLocationValue={setSearchLocationValue}
            setSearchLocationTextMethod={setSearchLocationTextMethod}
          />}
{activeZip3 !==null && activeZip3 !==undefined &&
<SearchPopoverZip3Items
            criteria={criteria}
            onAdd={onAdd}
            searchText={searchText}
            visible={isVisible}
            entity={entity}
            activeMetros={activeZip3}
          />
}


        </ul>
      </>
    )
  }
)
export default SearchPopover
